import {CashBookComponent} from "./component/cash-book/create/cash-book.component";
import {SettingsComponent} from './component/settings/settings.component';
import {HomeComponent} from "./component/home/home.component";
import {Routes} from "@angular/router";
import {AuthGuard} from "./login.guard";
import {CashBookListComponent} from "./component/cash-book/cash-book-list/cash-book-list.component";
import {RateCalculatorComponent} from "./component/rate-calculator/rate-calculator.component";
import {AccountBookingListComponent} from "./component/account-booking/account-booking-list/account-booking-list.component";
import {AccountBookingComponent} from "./component/account-booking/account-booking/account-booking.component";
import {AccountsComponent} from "./component/accounts/accounts/accounts.component";
import {AccountsListComponent} from "./component/accounts/accounts-list/accounts-list.component";
import {CashBookingPrintComponent} from "./component/cash-book/cash-booking-print/cash-booking-print.component";
import {AccountBookingPrintComponent} from "./component/account-booking/account-booking-print/account-booking-print.component";
import {DepositComponent} from "./component/deposit/deposit.component";

export const SECURE_ROUTES:Routes = [
  {path: '', redirectTo: 'home', pathMatch: 'full', canActivate: [AuthGuard]},
  {
    path: 'home', component: HomeComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'rate_calculator', component: RateCalculatorComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'cash_booking', component: CashBookComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'cash_booking_list', component: CashBookListComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'cash_booking_print', component: CashBookingPrintComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'accounts', component: AccountsComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'accounts_list', component: AccountsListComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'account_booking', component: AccountBookingComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'account_booking_list', component: AccountBookingListComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'account_booking_print', component: AccountBookingPrintComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'payment', component: DepositComponent,
    canActivateChild: [AuthGuard]
  },
  {
    path: 'settings', component: SettingsComponent,
    canActivateChild: [AuthGuard]
  }
];



// WEBPACK FOOTER //
// /root/production/sne-pro/src/app/secure_routes.ts